import React, { useState, useEffect } from 'react';
import { fetchGalleryInfrastructure } from '../utils/api';

const GalleryInfrastructure = ({ galleryId }) => {
  const [infrastructure, setInfrastructure] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const loadInfrastructure = async () => {
      if (!galleryId) {
        setIsLoading(false);
        return;
      }

      try {
        setIsLoading(true);
        const data = await fetchGalleryInfrastructure(galleryId);
        setInfrastructure(data);
      } catch (err) {
        console.error('Error loading gallery infrastructure:', err);
        setError(err.message);
      } finally {
        setIsLoading(false);
      }
    };

    loadInfrastructure();
  }, [galleryId]);

  if (isLoading) {
    return null; // Don't show loading state for infrastructure
  }

  if (error) {
    console.warn('Gallery infrastructure error:', error);
    // Continue with fallback infrastructure
  }

  return (
    <>
      {/* Default infrastructure (fallback) */}
      {/* Floor */}
      
      
      {/* Ceiling */}
      
      
      {/* Basic lighting */}
      <a-light type="ambient" color="#ffffff" intensity="0.6"/>
      <a-light type="directional" position="2 4 5" intensity="0.8"/>
      
      {/* Camera positioned to see the artworks */}
      <a-entity 
        id="camera" 
        camera 
        look-controls="pointerLockEnabled: false"
        wasd-controls="fly: false; acceleration: 50"
        position="0 5 20"
        rotation="0 0 0"
      />

      {/* Dynamic infrastructure from database */}
      {infrastructure.map((element, index) => {
        // Convert from inches to feet for A-Frame
        const posX = element.position_x / 12;
        const posY = element.position_y / 12;
        const posZ = element.position_z / 12;

        // If element has a source (GLB file), render as gltf-model
        if (element.source) {
          return (
            <a-entity
              key={`infra-${element.type}-${element.infrastructure_id || index}`}
              position={`${posX} ${posY} ${posZ}`}
              rotation={`${element.rotation_x || 0} ${element.rotation_y || 0} ${element.rotation_z || 0}`}
              scale={`${element.scale_x || 1} ${element.scale_y || 1} ${element.scale_z || 1}`}
              gltf-model={element.source}
              material="shader: standard; transparent: false; opacity: 1.0"
            />
          );
        }

        // Fallback for elements without GLB source (basic shapes)
        const width = element.width / 12;
        const height = element.height / 12;
        const depth = element.depth / 12;

        switch (element.type) {
          case 'wall':
            return (
              <a-box
                key={`infra-wall-${element.infrastructure_id || index}`}
                position={`${posX} ${posY} ${posZ}`}
                rotation={`${element.rotation_x || 0} ${element.rotation_y || 0} ${element.rotation_z || 0}`}
                width={width}
                height={height}
                depth={depth}
                color={element.color || '#F5F5F5'}
                opacity={element.opacity || 1.0}
                transparent={element.transparent || false}
              />
            );
          case 'light':
            return (
              <a-light
                key={`infra-light-${element.infrastructure_id || index}`}
                type={element.light_type || 'ambient'}
                position={`${posX} ${posY} ${posZ}`}
                color={element.color || '#ffffff'}
                intensity={element.intensity || 0.6}
              />
            );
          default:
            return null;
        }
      })}
    </>
  );
};

export default GalleryInfrastructure;